<template>
  <div v-loading="dataLoading" class="app-content-wrapper card-sort-edit-page">
    <div class="top-wrapper">
      <img class="img-top-wrapper" src="@/assets/images/checkout/img-top-card.png" />
      <div class="margin-left-20">
        <p class="top-title">{{$t('message.tableCommon.explanation')}}</p>
        <p class="top-desc">{{$t('message.checkout.explanation1')}}</p>
        <p class="top-desc">{{$t('message.checkout.explanation2')}}</p>
      </div>
    </div>
    <div>
      <template v-if="!isSee">
        <el-form ref="formRef" :model="form" :rules="formRules" class="card-sort-form" label-position="top">
          <el-form-item prop="country">
            <template #label>
              <span class="form-item-label">
                {{$t('message.transaction.country')}}
                <el-popover
                  placement="right"
                  :width="300"
                  trigger="hover">
                  <div>{{$t('message.checkout.allDesc')}}</div>
                  <template #reference>
                    <i class="margin-left-6 iconfont icon-daohanglantishiicon"></i>
                  </template>
                </el-popover>
              </span>
            </template>
            <el-select v-model="form.country" @change="handleCountryChange" :disabled="!!configCountry" :filterable="true">
              <el-option v-for="(p , i ) of countryList"
                :key="i+''"
                :label="p.label"
                :value="p.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="displayCardPriority" prop="priorityLevel">
            <template #label>
              <span class="form-item-label">
                {{$t('message.checkout.card')}}
                <i class="iconfont icon-ka"></i>
              </span>
            </template>
            <el-radio-group v-model="form.priorityLevel">
              <el-radio :label="'1'" :disabled="isSee">{{$t('message.checkout.highestPriority')}}</el-radio>
              <el-radio :label="'2'" :disabled="isSee">{{$t('message.checkout.lowestPriority')}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <div class="card-sort-form">
          <div class="card-sort-info">
            <div class="form-item-label">
              {{$t('message.transaction.country')}}
              <el-popover
                placement="right"
                :width="300"
                trigger="hover">
                <div>{{$t('message.checkout.allDesc')}}</div>
                <template #reference>
                  <i class="margin-left-6 iconfont icon-daohanglantishiicon"></i>
                </template>
              </el-popover>
            </div>
            <div class="form-item-value">{{getEnantiomericValue(countryList, form.country)}}</div>
          </div>
          <div v-if="displayCardPriority" class="card-sort-info">
            <div class="form-item-label">
              {{$t('message.checkout.card')}}
              <i class="iconfont icon-ka"></i>
            </div>
            <div class="form-item-value">{{form.priorityLevel === '1' ? $t('message.checkout.highestPriority') : $t('message.checkout.lowestPriority') }}</div>
          </div>
        </div>
      </template>
      <div class="card-sort-title margin-bottom-10 margin-top-30">
        <p>{{$t('message.checkout.cardSort')}}</p>
        <el-button v-if="!isSee && (sortData.length < cardTypeList.length)" size="small" icon="el-icon-plus" @click="handleAdd">{{$t('message.common.add')}}</el-button>
      </div>
      <div class="card-sort-list">
        <custom-table :table-set="tableCondition"
                      ref="table"
                      :is-first-automatic-visit="false"
                      :is-pagination-display="false">
                      <template #right="{ row }">
                        <div v-if="!isSee" class="table-item-right">
                          <span class="btn-delete margin-right-20" @click="handleClick(row)">{{$t('message.tableCommon.delete')}}</span>
                          <span class="ic-sort iconfont icon-xuanfu"></span>
                        </div>
                      </template>
        </custom-table>
      </div>
    </div>
    <el-button v-if="!isSee" class="margin-top-20" type="primary" @click="handleSubmit">{{$t('message.common.submit')}}</el-button>
    <validation-modal
      ref="addModal"
      :titleText="$t('message.checkout.addCardSort')"
      :showSubmitMessage="false"
      :validation-condition="cardCondition"
      :default-function="onAddCardInfo"></validation-modal>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>
import Sortablejs from 'sortablejs';

import validationModal from '@/components/modal/base-modal/validation-modal.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import { REQUIRED } from '@/components/validation/tool/validator';
import GlobalData from '@/utils/global/index';
import { initExhibitionTable, getEnantiomericValue } from '@/utils/tools/constant';
import { queryCardSortDetail, addCardSortInfo, updateCardSortInfo, querySortCardTypeList } from '@/views/checkout/api/card';

export default {
  components: {
    CustomMessage,
    CustomTable,
    validationModal,
  },
  data() {
    return {
      dataLoading: false,
      countryList: [],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.cardType' },
          key: 'cardTypeName',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.common.sort' },
          key: 'sort',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: '' },
          key: 'right',
          type: 'slot',
          classNames: 'table-item-right',
        },
      ],
      form: {
        country: '',
        priorityLevel: '2',
      },
      formRules: {
        country: [{ required: true, message: this.$t('message.validator.select', { input: this.$t('message.transaction.country') }) }],
      },
      isSee: false,
      configCountry: '',
      cardCondition: [{
        key: 'cardType',
        name: 'message.tableCommon.cardType',
        type: 'select',
        defValue: '',
        placeholder: this.$t('message.validator.select', { select: this.$t('message.tableCommon.cardType') }),
        isShowStar: true,
        rule: [REQUIRED],
        options: [],
      }],
      cardTypeList: [],
      sortData: [],
      displayCardPriority: false,
      merchantNo: '',
    };
  },
  mounted() {
    const { isSee, country, merchantNo } = this.$route.query;
    this.isSee = !!(+isSee);
    if (country) {
      this.configCountry = country;
      this.form.country = country;
    }
    if (merchantNo) {
      this.merchantNo = merchantNo;
    }
    this.initMethod();
  },
  methods: {
    getEnantiomericValue,
    async initMethod() {
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['COUNTRY']);
        this.countryList = (dict.COUNTRY || []).map(item => {
          return {
            label: item.description.split('-')[0],
            value: item.value,
          };
        });
        this.countryList.unshift({
          label: 'ALL',
          value: 'ALL',
        });

        this.sortData = [];
        if (this.configCountry) {
          const params = { country: this.configCountry };
          if (this.merchantNo) {
            params.merchantNo = this.merchantNo;
          }
          const res = await queryCardSortDetail(params);
          if (res && res.merchantCardTypes) {
            const data = res.merchantCardTypes || [];
            this.setTableData(data);
            if (res.priorityLevel) {
              this.form.priorityLevel = res.priorityLevel;
            }
          }

          await this.fetchCardTypeList();
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    async fetchCardTypeList() {
      const res = await querySortCardTypeList({ country: this.form.country });
      const list = res.cardTypeList || [];
      this.displayCardPriority = !!res.displayCardPriority;
      this.cardTypeList = list.map(item => ({
        value: item.cardType,
        label: item.cardTypeName || item.cardType,
      }));
    },
    setTableData(list = []) {
      const obj = {};
      let data = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (!obj[item.cardType]) {
          data.push({
            ...item,
          });
          obj[item.cardType] = true;
        }
      }
      data = data.map((item, index) => ({
        ...item,
        sort: index + 1,
        cardTypeName: item.cardTypeName || item.cardType,
      }));
      this.sortData = data;
      this.$refs.table.setTable(initExhibitionTable(data, true, data.length, data.length));
      setTimeout(() => {
        this.initSortablejs();
      });
    },
    initSortablejs() {
      if (this.sortable) {
        this.sortable.destroy();
        this.sortable = null;
      }
      const el = document.querySelector('.card-sort-list table tbody');
      if (el) {
        this.sortable = Sortablejs.create(el, {
          ghostClass: 'sortable-ghost',
          dataIdAttr: 'class',
          handle: '.ic-sort', // 格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
          animation: 150,
          forceFallback: true,
          onEnd: (evt) => {
            const { oldIndex, newIndex } = evt;
            const moveItem = this.sortData.splice(oldIndex, 1);
            this.sortData.splice(newIndex, 0, moveItem[0]);
            this.setTableData([...this.sortData]);
          },
        });
      }
    },
    async handleCountryChange() {
      this.dataLoading = true;
      try {
        // 重新获取卡种列表
        await this.fetchCardTypeList();
        if (this.sortData.length > 0) {
          this.setTableData([]);
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    handleAdd() {
      this.$refs.addModal.openModalAndCallBack((form) => {
        // 筛选过滤已存在的卡种
        const existList = this.sortData.map(item => item.cardType);
        const list = this.cardTypeList.filter(item => existList.indexOf(item.value) === -1);
        form.setValidationSelectOptions('cardType', list);
      });
    },
    async onAddCardInfo(params) {
      const data = [].concat(this.sortData);
      const cardType = params.cardType;
      let cardTypeName = cardType;
      for (let i = 0; i < this.cardTypeList.length; i++) {
        if (this.cardTypeList[i].value === cardType) {
          cardTypeName = this.cardTypeList[i].label;
          break;
        }
      }
      data.unshift({
        cardType: params.cardType,
        cardTypeName: cardTypeName || cardType,
      });
      this.setTableData(data);
    },
    handleClick(row) {
      this.$refs.customMessage.openHttpModal({
        titleHtml: this.$t('message.common.prompt'),
        contentHtml: `${this.$t('message.common.deleteConfirm')}?`,
        httpFunction: async () => {
          const list = this.sortData.filter(item => item.cardType !== row.cardType);
          this.setTableData(list);
        },
      });
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.dataLoading = true;
          try {
            const MethodSub = this.configCountry ? updateCardSortInfo : addCardSortInfo;
            const data = {
              country: this.form.country,
              cardTypeList: this.sortData,
            };
            if (this.displayCardPriority) {
              data.priorityLevel = this.form.priorityLevel;
            }
            await MethodSub(data);
            ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
            this.$router.go(-1);
          } catch (err) {
            //
          }
          this.dataLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.card-sort-edit-page {
  .top-wrapper {
    display: flex;
    align-items: center;
    margin-top: 36px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0,32,63,0.08);

    .img-top-wrapper {
      width: 107px;
      height: 78px;
    }

    .top-title {
      font-size: 16px;
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      color: $color-text-primary;
      line-height: 28px;
    }

    .top-desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 21px;
    }
  }

  .card-sort-form {
    width: 450px;
    margin-top: 20px;

    .card-sort-info {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .form-item-label {
        width: 100px;
      }
    }

    .form-item-label {
      font-size: 18px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: $color-text-primary;
      line-height: 32px;
    }

    .icon-daohanglantishiicon {
      color: rgba(38,67,115,0.6);
      font-size: 14px;
      cursor: pointer;
    }
  }

  ::v-deep #customTable {
    .el-table__cell .cell {
      min-height: 19px;
    }
    .table-item-right {
      .cell {
        justify-content: flex-end;
        padding-right: 60px;
      }

      .btn-delete {
        cursor: pointer;
        color: $color-primary;
      }

      .ic-sort {
        width: 12px;
        height: 13px;
        cursor: pointer;
      }
    }
  }

  .card-sort-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: $color-text-primary;
    line-height: 32px;
  }
}
</style>
